<template>
  <div class="py-6">
    <template v-if="pageError">
      <page-error :description="pageErrorMsg" />
    </template>
    <template v-else>
      <!--      <div class="fixed-edit-btn">-->
      <!--        <el-button v-if="editSubmit" @click="onEditAnswer">修改</el-button>-->
      <!--      </div>-->
      <div
          class="preview-page-tips"
          ref="fixedHeader"
      >
        <div class="edit-tips" :class="editSubmit?'enabled-edit':'disabled-edit'">
          <template v-if="editSubmit">
            <span>点击</span>
            <span @click="onEditAnswer" class="text-theme cursor-pointer"> 修改 </span>
            <span>，可修改已填内容</span>
          </template>
          <template v-else>
            <span>已填内容仅可查看，不可修改</span>
          </template>
        </div>
      </div>
      <div class="question-group relative" ref="mainContainer" :class="baseClass">
        <template v-if="isEditAnswer">
          <div v-for="question in list" :key="question.q_id">
            <question-item :question="question" :enable-question-index="enableQuestionIndex"/>
          </div>
        </template>
        <template v-else>
          <div v-for="question in list" :key="question.q_id" class="relative">
            <preview-question :question="question" :enable-question-index="enableQuestionIndex"/>
            <div v-if="!notMaskTypes.includes(question.questionType)" class="absolute inset-0 z-50"></div>
          </div>
        </template>
      </div>
      <div class="text-center mt-5" v-if="!disableSubmitButton">
        <template v-if="!isEditAnswer">
          <el-button v-if="showPrevBtn" type="primary" @click="getPrevPage">上一页</el-button>
          <el-button v-if="showNextBtn" type="primary" @click="getNextPage">下一页</el-button>
        </template>
        <template v-else>
          <el-button type="primary" @click="onSubmitEdit">提交修改</el-button>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import { answerPreview, questionType } from 'dygc'
import PcHeader from '@/components/PcHeader'
import PreviewQuestion from '@/components/PreviewQuestion'
import QuestionItem from '@/components/QuestionItem'
import PageError from '@/components/PageError'

export default {
  name: 'Preview',
  components: { PageError, QuestionItem, PcHeader, PreviewQuestion },
  extends: answerPreview,
  data() {
    return {
      notMaskTypes: [
        questionType.MATRIX_SCALE,
        questionType.MATRIX_SINGLE_CHOICE,
        questionType.MATRIX_MULTIPLE_CHOICE,
        questionType.CUSTOM_MULTIPLE_SCALE,
        questionType.MATRIX_FILL,
        questionType.MATRIX_SELECT_CHOICE,
        questionType.MATRIX_AUTO,
        questionType.MATRIX_COMPOSE,
        questionType.MAX_DIFF
      ]
    }
  },
  computed:{
    baseClass(){
      return this.isBaseWidth ? 'base-width': ''
    },
    isBaseWidth(){
      return !this.$bus.params.fullWidth
    },
  }
}
</script>

<style lang="scss">
.preview-page-tips {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 100;

  font-size: 12px;

  text-align: center;
  line-height: 16px;

  .edit-tips {
    width: 800px;
    padding: 8px 0;
    margin: 0 auto;

    &.enabled-edit {
      color: rgba(0, 0, 0, .65);
      background-color: #F0F8FF;
    }

    &.disabled-edit {
      color: #E34152;
      background-color: #FFF1F0;
    }
  }

}
</style>
